// src/services/authService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8080';

const login = async (phone, password) => {
  // alert(username);
  const response = await axios.post(`${API_URL}/auth/login`, {
    phone,
    password,
  });
  localStorage.setItem('token', response.data.access_token);
  return response.data;
};

const forgotPassword = async (email) => {
  await axios.post(`${API_URL}/auth/forgot-password`, { email });
};

const changePassword = async (data) => {
  return await axios.post(`${API_URL}/auth/change-password`, data);
};

const resetPassword = async (token, password) => {
  await axios.post(`${API_URL}/auth/reset-password`, { token, password });
};

const authService = {
  login,
  forgotPassword,
  resetPassword,
  changePassword,
};

export default authService;
